import React from 'react';

import { StyledDescription } from './StyledDescription';

export type Props = {
  children?: React.ReactNode;
  content?: string | null;
  maxLineCount?: number;
};


export const Description = ({ children, content, maxLineCount = 2 }: Props) => {
  
  if (content) return <StyledDescription dangerouslySetInnerHTML={{__html: content}} maxLineCount={maxLineCount}></StyledDescription>
  return <StyledDescription maxLineCount={maxLineCount}>{children}</StyledDescription>;
};
